import React from 'react'

export const useContextMenuClick = () => {
  const [contextMenuPosition, setContextMenuPosition] = React.useState<null | {
    x: number
    y: number
  }>(null)

  const onContextMenu = React.useCallback(
    (e: React.MouseEvent) => {
      if (!contextMenuPosition) {
        e.preventDefault()
        e.stopPropagation()
        setContextMenuPosition({
          x: e.nativeEvent.offsetX,
          y: e.nativeEvent.offsetY,
        })
      } else {
        setContextMenuPosition(null)
      }
    },
    [contextMenuPosition]
  )
  const closeContextMenu = React.useCallback(() => {
    setContextMenuPosition(null)
  }, [])
  return {
    onContextMenu,
    contextMenuPosition,
    closeContextMenu,
  }
}
